import React from "react";
import Dashboard from "./Dashboard.js";
import information from "../../assets/information.png";
import OutfitElement from "../OutfitElement.js"; // Import the missing component
import "./DashboardCommon.css";

const TopOutfitsDashboard = ({ outfitsList, handleOutfitClick }) => {
  return (
    <>
      <div className="header_flex">
        <h4 className="header_title">Top Outfits</h4>
        <img className="header_image" src={information} alt="information" />
        <p className="header_description">Mes Outfits les plus cotes</p>
      </div>
      <div className="list_flex">
        {outfitsList && outfitsList.length > 0 ? (
          outfitsList.map((item, index) => (
            <OutfitElement
              key={index}
              item={item}
              top={index + 1}
              heart={item.likes}
              commission={item.commission}
              ventes={item.ventes}
              produit={item.picture}
              handleClick={handleOutfitClick}
            />
          ))
        ) : (
          <h4>No data</h4>
        )}
      </div>
      <div className="divider_div3" />
    </>
  );
};

export default TopOutfitsDashboard;
